import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { checkRole } from "../../../utils/role";
import { ToastContainer, toast } from "react-toastify";
import { Auth } from "aws-amplify";
import {
  Document,
  Page,
  pdf,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import moment from "moment";
import {
  getCurrentLocalDateTime,
  months,
  pad,
} from "../../../utils/getLocalDateTime";
import { format } from "date-fns";
import numeral from "numeral";
import { getAmountOwedDueNTF, getAmountOwedDueTF } from "../utils/leasing.u";
import API from "../api/api.main"

function FootageIssueAsk({ selectedRows }) {
  const { user } = useSelector((state) => state.initializeApp);

  var isProcessing = false;

  const styles = StyleSheet.create({
    page: {
      fontFamily: "Sarabun",
      padding: 24,
      fontSize: 12,
      backgroundColor: "#fff",
    },
    content: {
      paddingHorizontal: 16,
      // textIndent: 18
    },
    date: {
      marginTop: 3,
      marginBottom: 20,
      textAlign: "center",
    },
    header: {
      fontSize: 12,
      textAlign: "center",
    },
    text: {
      margin: 12,
      fontSize: 12,
      lineHeight: 1.6,
      // marginVertical: 4,
      // fontSize: 12,
      fontFamily: "Sarabun",
    },
    textContent: {
      maginTop: 18,
      marginBottom: 18,
      lineHeight: 1.6,
      fontFamily: "Sarabun",
    },
    bold: {
      fontFamily: "Sarabun",
      fontWeight: "bold",
      lineHeight: 1.6,
    },
    address: {
      textAlign: "right",
      marginVertical: 16,
    },
  });

  const stylesEnvelop = StyleSheet.create({
    page: {
      fontFamily: "Cordia New",
      padding: 10,
      fontSize: 14,
      backgroundColor: "#fff",
    },
    header: {
      textAlign: "right",
      marginRight: "3px",
      marginTop: "2px",
    },
    section: {
      marginTop: "36px",
      marginLeft: "42px",
    },
    space: {
      margin: "3px",
    },
  });

  const getNumberText = (value, concat = "") => {
    if (value % 10 >= 9) return "เก้า" + concat;
    if (value % 10 >= 8) return "แปด" + concat;
    if (value % 10 >= 7) return "เจ็ด" + concat;
    if (value % 10 >= 6) return "หก" + concat;
    if (value % 10 >= 5) return "ห้า" + concat;
    if (value % 10 >= 4) return "สี่" + concat;
    if (value % 10 >= 3) return "สาม" + concat;
    if (value % 10 >= 2) return "สอง" + concat;
    if (value % 10 >= 1) return "หนึ่ง" + concat;
    return "";
  };

  const getThaiAmount = (value = 1819) => {
    var grand = value / 10000;
    var thounsand = value / 1000;
    var hundred = value / 100;
    var deci = value / 10;
    var last = value % 10;
    var lastText = getNumberText(last);
    var deciText = getNumberText(deci, "สิบ");
    if (deci >= 1 && deci < 2) deciText = "สิบ";
    if (deci == 2) deciText = "ยี่สิบ";
    var hundredText = getNumberText(hundred, "ร้อย");
    var thounsandText = getNumberText(thounsand, "พัน");
    var grandText = getNumberText(grand, "หมื่น");
    if (last == 1) lastText = "เอ็ด";
    return (
      grandText + thounsandText + hundredText + deciText + lastText + "บาทถ้วน"
    );
  };

  const generatePdfDocument = async (isFirst = false) => {
    if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
    else isProcessing = true;

    const dataInterest = await API.get(
      "MoneyHubAdmin",
      `/leasing/interest?name=INTEREST`,
      {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      }
    );

    const dataInterestPerYear = await API.get(
      "MoneyHubAdmin",
      `/leasing/interest?name=INTEREST_PER_YEAR`,
      {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      }
    );

    const INTEREST = dataInterest.INTEREST;
    const INTEREST_PER_YEAR = dataInterestPerYear.INTEREST_PER_YEAR;

    let filename = `EXPORT_${
      isFirst ? "first" : "secound"
    }_${new Date().toISOString()}.pdf`;

    let updateSelectedRows = await Promise.all(
      selectedRows.map(async (row) => {
        const dataLoan = await API.get(
          "MoneyHubAdmin",
          `/leasing/loan/${row?.original?.loan_id}`,
          {
            queryStringParameters: {
              fields: "installments",
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          }
        );
        return {
          ...row,
          original: {
            ...row.original,
            installments: dataLoan?.leasing?.installments,
          },
        };
      })
    );

    /// Cal increment Lamba to get Count here
    try {
      let blob = await pdf(
        <PdfDocument
          selectedRows={updateSelectedRows}
          INTEREST={INTEREST}
          INTEREST_PER_YEAR={INTEREST_PER_YEAR}
          title={filename}
          isFirst={isFirst}
        />
      ).toBlob();
      saveAs(blob, filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
  };

  const generatePdfDocumentEnvelope = async () => {
    if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
    else isProcessing = true;

    let filename = `EXPORT_${new Date().toISOString()}.pdf`;

    /// Cal increment Lamba to get Count here
    try {
      let blob = await pdf(
        <PdfDocumentEnvelope title={filename} loan={selectedRows} />
      ).toBlob();
      saveAs(blob, filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
  };

  const PdfDocumentEnvelope = ({ loan = [], isCurrentAddress = true }) => {
    return (
      <Document>
        {loan.map((row, index) => {
          const {
            loan_id,
            name,
            lastname,
            address,
            addressCode,
            addressDesc,
            officialAddressCode,
            officialAddressDesc,
            currentAddress,
          } = row.original;
  
          let myAddress = addressCode + " " + addressDesc + " " + address;
  
          if (isCurrentAddress) {
            myAddress =
              officialAddressCode +
              " " +
              officialAddressDesc +
              " " +
              currentAddress;
          }
  
          return (
            <Page key={index} size={[288, 216]} style={stylesEnvelop.page}>
              <View style={stylesEnvelop.header}>
                <Text>เลขที่สัญญา {loan_id}</Text>
              </View>
              <View style={stylesEnvelop.section}>
                <Text>กรุณาส่ง</Text>
                <View style={stylesEnvelop.space}></View>
                <Text>คุณ{`${name} ${lastname}`}</Text>
                <View style={stylesEnvelop.space}></View>
                <Text>ที่อยู่ {`${myAddress}`}</Text>
                {/* <View style={stylesEnvelop.space}></View>
                <Text>{`${address}`}</Text> */}
              </View>
            </Page>
          );
        })}
      </Document>
    );
  };

  const PdfDocument = ({
    selectedRows = [],
    isFirst = false,
    INTEREST,
    INTEREST_PER_YEAR,
  }) => {
    return (
      <Document>
        {selectedRows.map((row, index) => {
          const {
            name,
            lastname,
            loan_id,
            transferDate,
            overdue_date,
            installments,
            requestamount,
            type,
            category,
          } = row.original;

          //  console.log("ROW", row);

          const currentInterest =
            category === "TF" ? INTEREST_PER_YEAR : INTEREST;

          const fullname = `${name} ${lastname}`;

          var now_th = moment.locale("th");
          var today = moment().add(543, "year").format("DD/MM/YYYY");
          var currentDate = moment().date();
          var currentYear = moment().add(543, "year").year();
          var rawMonth = moment().format("MM");
          var currentMonth = "มกราคม";
          if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
          if (rawMonth == "03") currentMonth = "มีนาคม";
          if (rawMonth == "04") currentMonth = "เมษายน";
          if (rawMonth == "05") currentMonth = "พฤษภาคม";
          if (rawMonth == "06") currentMonth = "มิถุนายน";
          if (rawMonth == "07") currentMonth = "กรกฎาคม";
          if (rawMonth == "08") currentMonth = "สิงหาคม";
          if (rawMonth == "09") currentMonth = "กันยายน";
          if (rawMonth == "10") currentMonth = "ตุลาคม";
          if (rawMonth == "11") currentMonth = "พฤศจิกายน";
          if (rawMonth == "12") currentMonth = "ธันวาคม";

          const convertRequestTime = getCurrentLocalDateTime(
            new Date(transferDate)
          );
          const overdueDate = getCurrentLocalDateTime(new Date(overdue_date));
          const owedDue =
            category === "TF"
              ? getAmountOwedDueTF(row.original, installments)
              : getAmountOwedDueNTF(row.original, installments);

          return (
            <Page size="A4" style={styles.page} key={index}>
              <Text style={styles.header}>
                หนังสือบอกกล่าวทวงถามให้ชำระหนี้ครั้งที่ {isFirst ? "1" : "2"}{" "}
              </Text>
              <View style={styles.content}>
                <View style={styles.address}>
                  <Text>
                    ทำที่ 1010 อาคารชินวัตรทาวเวอร์ 3 ชั้นที่ 12
                    ถนนวิภาวดีรังสิต{" "}
                  </Text>
                  <Text>แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร </Text>
                </View>

                <View style={styles.date}>
                  <Text>
                    วันที่ {currentDate} เดือน {currentMonth} ปี {currentYear}
                  </Text>
                </View>

                <View style={{ maginTop: 16, marginBottom: 16 }}>
                  <Text style={styles.textContent}>
                    <Text style={styles.bold}>เรียน</Text>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Text style={styles.text}>คุณ {fullname} </Text>
                    <Text style={styles.bold}>("ผู้กู้")</Text>
                  </Text>

                  <Text style={styles.textContent}>
                    <Text style={styles.bold}>เรื่อง</Text>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Text style={styles.text}>
                      ขอให้ชำระหนี้ค้างชำระตามสัญญาสินเชื่อ{" "}
                    </Text>
                  </Text>

                  <Text style={styles.textContent}>
                    <Text style={styles.bold}>อ้างถึง</Text>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Text style={{ ...styles.text }}>
                      สัญญาสินเชื่อ เลขที่ {loan_id} ฉบับลงวันที่{" "}
                      {convertRequestTime.date}{" "}
                      {months[convertRequestTime.monthIndex].monthTh}{" "}
                      {+convertRequestTime.year + 543} ระหว่าง ผู้กู้ และ บริษัท
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;มันนี่
                      ฮับ เซอร์วิส จำกัด ("บริษัท" หรือ "ผู้ให้กู้")
                      ("สัญญาสินเชื่อ"){" "}
                    </Text>
                  </Text>
                </View>

                <Text style={{ ...styles.textContent, textAlign: "left" }}>
                  <Text style={styles.bold}>สิ่งที่ส่งมาด้วย&nbsp;</Text>
                  <Text>
                    &nbsp;&nbsp;ใบแจ้งยอดรายการและภาระหนี้ ฉบับลงวันที่{" "}
                    {overdueDate.date}
                    &nbsp;
                    {months[overdueDate.monthIndex].monthTh}&nbsp;
                    {+overdueDate.year + 543} ออกโดยบริษัท ถึง ผู้กู้{" "}
                  </Text>
                  <View></View>
                  <Text>
                    (แสดงภาระหนี้ค้างชำระรวมเป็นเงินจำนวนทั้งสิ้น&nbsp;
                    {numeral(owedDue).format("0,0.00")} บาท ทั้งนี้
                    หนี้ค้างชำระดังกล่าวยังไม่รวมค่าใช้จ่ายใดๆ
                    ในการดำเนินการติดตามทวงถามหนี้ ){" "}
                  </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    ตามสัญญาสินเชื่อที่อ้างถึง ท่าน ในฐานะผู้กู้
                    ได้เข้าทำสัญญาสินเชื่อกับบริษัท มันนี่ ฮับ เซอร์วิส{" "}
                  </Text>
                  <Text break={false}>
                    จำกัด ในฐานะผู้ให้กู้ และกู้ยืมเงินไปจากบริษัท
                    ในฐานะผู้ให้กู้ เป็นเงินจำนวน{" "}
                    {numeral(requestamount).format("0,0.00")} บาท (
                    {getThaiAmount(requestamount)})
                  </Text>
                  <View></View>
                  <View></View>

                  <Text>
                    &nbsp;โดยท่านตกลงชำระดอกเบี้ยในอัตราร้อยละ {currentInterest}
                    % ต่อปีของต้นเงินดังกล่าว{" "}
                  </Text>
                  <Text>รายละเอียดปรากฎตามสัญญาสินเชื่อ </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                    textIndent: 30,
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    บริษัทขอเรียนให้ท่านทราบว่า
                    ท่านมียอดหนี้ค้างชำระตามสัญญาสินเชื่อซึ่งเลยกำหนดชำระและพึง&nbsp;&nbsp;{" "}
                  </Text>
                  <Text>
                    ต้องชำระให้แก่บริษัท เป็นจำนวนทั้งสิ้น{" "}
                    {numeral(owedDue).format("0,0.00")} บาท
                  </Text>
                  <Text>
                    &nbsp;({getThaiAmount(owedDue)}) รายละเอียดภาระหนี้ค้าง{" "}
                  </Text>
                  <Text>
                    ชำระและรายละเอียดการคำนวณภาระหนี้ปรากฏตามใบแจ้งยอดรายการและภาระหนี้ที่ได้แนบท้ายมากับ&nbsp;{" "}
                  </Text>
                  <Text>
                    หนังสือฉบับนี้ (ทั้งนี้
                    หนี้ค้างชำระดังกล่าวยังไม่รวมค่าใช้จ่ายใด ๆ
                    ในการดำเนินการติดตามทวงถามหนี้ ซึ่ง &nbsp;{" "}
                  </Text>
                  <Text>บริษัทจะเรียกเก็บจากท่าน (หากมี) ต่อไป) </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                    textIndent: 30,
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    โดยหนังสือบอกกล่าวทวงถามให้ชำระหนี้
                    <Text style={styles.bold}> ("หนังสือฉบับนี้") </Text>{" "}
                    บริษัทจึงเรียนมายังท่านเพื่อขอให้ท่านชำระ{" "}
                  </Text>
                  <Text>
                    หนี้ค้างชำระจำนวนดังกล่าวทั้งหมดให้แก่บริษัทตามรูปแบบการชำระเงินและผ่านช่องทางการ
                    &nbsp;&nbsp;&nbsp;
                  </Text>
                  <Text>
                    ชำระต่างๆที่ระบุในใบแจ้งยอดรายการและภาระหนี้ที่แนบมานี้{" "}
                    {isFirst ? "ภายใน 7 " : "อย่างเร็วที่สุด ภายใน 3 "}
                    วัน นับจากวันที่ได้รับหนังสือ ฉบับนี้
                  </Text>
                  <Text
                    style={{ ...styles.bold, textDecoration: "underline" }}
                    break={true}
                  >
                    &nbsp;หากบริษัทยังไม่ได้รับชำระหนี้จากท่านเมื่อพ้นระยะเวลาดังกล่าวแล้วบริษัท
                    {isFirst ? "" : "\n"}มีความจำเป็นที่อาจจะ
                    {isFirst ? "\n" : ""}
                    ต้องดำเนินการตามสัญญาและ/หรือดำเนินการบังคับชำระหนี้จากท่านตามกฎหมาย
                    {isFirst ? " " : "\n"}ต่อไป อนึ่ง หากท่าน{" "}
                    {isFirst ? "\n" : " "}ได้
                    มีการชำระหนี้ให้แก่บริษัทแล้วก่อนได้รับหนังสือฉบับนี้บริษัทต้องขออภัย
                    เป็นอย่างสูงมา ณ โอกาสนี้ด้วย&nbsp;&nbsp; {"\n"}
                  </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    หากหนังสือฉบับนี้ส่งโดยจดหมายอิเล็กทรอนิกส์โดยสื่ออิเล็กทรอนิกส์หรือโดยสื่อเทคโนโลยี{" "}
                  </Text>

                  <Text>
                    สารสนเทศประเภทอื่นก็ไม่กระทบต่อความสมบูรณ์หรือผลบังคับของหนังสือฉบับนี้
                    และให้ถือว่าหนังสือ{" "}
                  </Text>

                  <Text>
                    ฉบับนี้ที่ส่งทางจดหมายอิเล็กทรอนิกส์ โดยสื่ออิเล็กทรอนิกส์
                    หรือโดยสื่อเทคโนโลยีสารสนเทศประเภท{" "}
                  </Text>

                  <Text>อื่นดังกล่าว เป็นต้นฉบับ </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    เมื่อท่านได้รับหนังสือฉบับนี้แล้วบริษัทขอให้ท่านตรวจสอบยอดหนี้ค้างชำระและรายละเอียดที่{" "}
                  </Text>

                  <Text>
                    ระบุในหนังสือฉบับนี้และตามใบแจ้งยอดรายการและภาระหนี้ที่แนบท้ายหนังสือฉบับนี้หากท่านมี{" "}
                  </Text>

                  <Text>
                    ข้อโต้แย้งหรือเรื่องร้องเรียนใด ๆ
                    กรุณาติดต่อมายังบริษัทภายใน {isFirst ? "7" : "3"} วัน{" "}
                  </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    marginTop: 16,
                    textAlign: "center",
                  }}
                >
                  จึงเรียนมาเพื่อโปรดดำเนินการโดยเร็ว{" "}
                </Text>

                <View
                  style={{
                    ...styles.textContent,
                    marginTop: 24,
                    textAlign: "center",
                  }}
                >
                  <Text>ขอแสดงความนับถือ </Text>
                  <Text>ลงนามเพื่อและในนามของ </Text>
                  <Text style={styles.bold}>
                    บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
                  </Text>
                </View>

                <View
                  style={{
                    ...styles.textContent,
                    marginTop: 24,
                    textAlign: "center",
                  }}
                >
                  <Text>โดย_________________________ </Text>
                  <Text>ชื่อ:_________________________ </Text>
                  <Text>ตำแหน่ง: ผู้จัดการฝ่ายเร่งรัดหนี้สิน </Text>
                  <Text>
                    (โดยหนังสือมอบอำนาจ ฉบับลงวันที่ {currentDate}{" "}
                    {currentMonth} {currentYear}){" "}
                  </Text>
                </View>

                <View
                  style={{
                    ...styles.textContent,
                    marginTop: 20,
                    textAlign: "left",
                  }}
                >
                  <Text style={styles.bold}>หมายเหตุ : </Text>
                  <Text>
                    สอบถามรายละเอียดเพิ่มเติม ติดต่อศูนย์บริการลูกค้า บริษัท
                    มันนี่ ฮับ เซอร์วิส จำกัด{" "}
                  </Text>
                  <Text>
                    โทร 02-791-1300 วันเวลาทำการ 08:30-17:30 น. หรือ
                    ติดต่อฝ่ายเร่งรัดหนี้สิน โทร 02-791-1300{" "}
                  </Text>
                </View>
              </View>
            </Page>
          );
        })}
      </Document>
    );
  };

  if (
    checkRole(user.groups, [
      "SuperAdmin",
      "AnalyzeApprove",
      "Debt",
      "CustomerService",
      "Admin",
    ])
  ) {
    return (
      <React.Fragment>
        <button
          disabled={!selectedRows.length}
          className={classNames(
            "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
            {
              "bg-gray-300 cursor-not-allowed text-white": !selectedRows.length,
              "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                selectedRows.length,
            }
          )}
          onClick={() => generatePdfDocumentEnvelope(true)}
        >
          ซองจดหมาย
        </button>
        <button
          disabled={!selectedRows.length}
          className={classNames(
            "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
            {
              "bg-gray-300 cursor-not-allowed text-white": !selectedRows.length,
              "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                selectedRows.length,
            }
          )}
          onClick={() => generatePdfDocument(true)}
        >
          ออกหนังสือทวงถามครั้งแรก
        </button>
        <button
          disabled={!selectedRows.length}
          className={classNames(
            "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
            {
              "bg-gray-300 cursor-not-allowed text-white": !selectedRows.length,
              "border-pink-500 text-pink-500 hover:bg-pink-600 hover:text-white":
                selectedRows.length,
            }
          )}
          onClick={() => generatePdfDocument()}
        >
          ออกหนังสือทวงถามครั้งที่สอง
        </button>
      </React.Fragment>
    );
  }

  return null;
}

export default FootageIssueAsk;
